import PropTypes from 'prop-types';
import { Heading, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { Icon } from '@eti/components';
import { TripDetailsWrapper, IconWrapper, boundMargins } from './ItineraryComponents';

const getBeforeLineStyle = (isStartingPoint) => {
  return isStartingPoint ? 'dashed' : 'solid';
};

const getAfterLineStyle = (isStartingPoint, hasNextStop) => {
  if (isStartingPoint) {
    return 'solid';
  }
  if (hasNextStop) {
    return 'dashed';
  }
  return 'none';
};

const wrapperStyles = (isStartingPoint, hasNextStop) => css`
  &::before {
    border-left: 1px ${getBeforeLineStyle(isStartingPoint)} ${vars.colors.inputs.border};
    ${boundMargins};
    top: 0;
  }

  &::after {
    border-left: 1px ${getAfterLineStyle(isStartingPoint, hasNextStop)} ${vars.colors.inputs.border};
    bottom: 0;
    ${boundMargins}
  }
`;

const timeStyles = css`
  display: flex;
  flex: 0 0 89px;
  justify-content: center;
  text-align: center;
`;

const locationWrapperStyles = css`
  display: flex;
  flex-direction: column;
  padding-inline: 20px 16px;
`;

const ItineraryLocationTime = ({ airportName, cityName, hasNextStop, isStartingPoint, time }) => {
  return (
    <TripDetailsWrapper
      className={wrapperStyles(isStartingPoint, hasNextStop)}
      data-testid="trip-segment-location-time"
    >
      <div className={timeStyles} data-testid="trip-segment-time">
        <Heading level={2}>{time}</Heading>
      </div>
      <IconWrapper>
        <Icon color={vars.colors.text.primary} id="circle" size="8px" />
      </IconWrapper>
      <div className={locationWrapperStyles} data-testid="trip-segment-location">
        <Heading level={4}>{cityName}</Heading>
        <p>{airportName}</p>
      </div>
    </TripDetailsWrapper>
  );
};

ItineraryLocationTime.propTypes = {
  airportName: PropTypes.string,
  cityName: PropTypes.string,
  hasNextStop: PropTypes.bool,
  isStartingPoint: PropTypes.bool,
  time: PropTypes.string,
};

export default ItineraryLocationTime;
